import React, { Component } from 'react';
import { HexAlphaColorPicker, HexColorInput } from 'react-colorful';

class LayoutSettings extends Component {
    constructor(props) {
        super(props);
    }

    renderIncrementalSetting = (label, value, name, step = 1, min = 0) => {
        let displayValue = value;
        let unit = 'px';

        if (typeof value === 'string') {
            const match = value.match(/^([\d.]+)(.*)$/);
            if (match) {
                displayValue = match[1];
            }
        }

        return (
            <div className='mjwi-row'>
                <div className='mjwi-col50'>
                    <label>{label}</label>
                </div>
                <div className='mjwi-col50'>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                            type="number"
                            name={name}
                            value={displayValue || ''}
                            onChange={(e) => {
                                const val = e.target.value;
                                this.props.handleInputChange({ target: { name, value: val ? `${parseFloat(val) || 0}${unit}` : `0${unit}` } }, ['layout']);
                            }}
                            className="mjwi-input"
                            min={min}
                            style={{ flexGrow: 1 }}
                        /> {unit}
                    </div>
                </div>
            </div>
        );
    };

    renderDropdown = (label, name, value, options) => (
        <div className="mjwi-row">
            <div className="mjwi-col50">
                <label>{label}</label>
            </div>
            <div className="mjwi-col50">
                <select
                    name={name}
                    value={value}
                    onChange={(e) => this.props.handleInputChange(e, ['layout'])}
                    className="mjwi-select"
                >
                    {options.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );

    renderColorPicker = (label, color, field) => (
        <div className="mjwi-row">
            <div className="mjwi-col50">
                <label>{label}</label>
            </div>
            <div className="mjwi-col50 mjwi-clr-picker">
                <span
                    className="clrPickerVal"
                    style={{ backgroundColor: color }}
                ></span>
                <HexAlphaColorPicker
                    color={color}
                    onChange={(newColor) => this.props.setColorsAndPreview('layout', field, newColor)}
                    className="mjwi-apfl-color-picker"
                    style={{ display: 'none' }}
                />
                <HexColorInput
                    color={color}
                    onChange={(newColor) => this.props.setColorsAndPreview('layout', field, newColor)}
                    className="mjwi-color-input"
                />
            </div>
        </div>
    );

    renderLayoutSettings = () => {
        const { tripadvisor } = this.props;
        const layoutTypeOptions = [
            { value: 'list', label: 'List' },
            { value: 'masonry', label: 'Masonry' },
            { value: 'carousel', label: 'Carousel' }
        ];

        return (
            <div className='mjwi-acc-panel-wrapper'>
                {this.renderDropdown('Layout Type', 'layout.layoutType', tripadvisor.layout.layoutType, layoutTypeOptions)}
            </div>
        );
    };

    render() {
        return this.props.renderSection('Layout', this.renderLayoutSettings(), 'layout-settings');
    }
}

export default LayoutSettings;